import { NgModule } from '@angular/core';
import { TableActionsComponent } from './table-actions.component';
import { CommonModule } from '@angular/common';
import { DropdownModule } from '@circe/dropdown';
import { KeyboardEmitterModule } from '@circe/event-controls';
import { BoxModelModule } from '@circe/core';


@NgModule({
  declarations: [TableActionsComponent],
  imports: [
    CommonModule,
    DropdownModule,
    KeyboardEmitterModule,
    BoxModelModule.forChild()
  ],
  exports: [TableActionsComponent]
})
export class TableActionsModule {}
